// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"38":"ba5fc4b0b4555d9e28cf","72":"4093c01ddddc57081adc","93":"e6cb054cd2dd5aaaf395","308":"31d51a9f90b992de3505","347":"14b2f71132740459ccee","561":"b1c1c0b2b123d772f7ab","700":"71b63a96d97170772c12","757":"0ef2c6d6b02be8d299c5"}[chunkId] + ".js";
};